// extracted by mini-css-extract-plugin
module.exports = {"Article__bottom":"article_Article__bottom__5f2Za","Article__header":"article_Article__header__ReQ3r","Article__navigation":"article_Article__navigation___dEIi"};